export default `<div class="styles__CategoryList">
<div class="column featured">
  <div class="group featured">
    <span>
      <h2 class="title">Featured</h2>
    </span>
    <ul>

      <li>
        <a href="/campaign/find-yourself-outside/stories?cm_sp=topnav_guide_featured_fyostories" title="Find Yourself Outside: Stories">
          <div class="item">
            <div class="item-label">Find Yourself Outside: Stories</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/find-yourself-outside/everyday-wellness?cm_sp=topnav_guide_featured_everydaywellness" title="Everyday Wellness">
          <div class="item">
            <div class="item-label">Everyday Wellness</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/find-yourself-outside/outbound-collective?cm_sp=topnav_guide_featured_trailtips" title="Trail Tips and Adventures">
          <div class="item">
            <div class="item-label">Trail Tips and Adventures</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/find-yourself-outside/sleep-under-the-stars?cm_sp=topnav_guide_featured_sleepunderthestars" title="Sleep Under the Stars">
          <div class="item">
            <div class="item-label">Sleep Under the Stars</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/eb-contributors?cm_sp=topnav_guidepost_featured_ebcontibutors" title="EB Contributors">
          <div class="item">
            <div class="item-label">EB Contributors</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/guide-built-process?cm_sp=topnav_guide_featured_guidebuilt" title="The Guide Built Process">
          <div class="item">
            <div class="item-label">The Guide Built Process</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/awards?cm_sp=topnav_guide_featured_awardwinners" title="Award Winners">
          <div class="item">
            <div class="item-label">Award Winners</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/leaders?cm_sp=topnav_guide_featured_oneoutsideleaders" title="One Outside Leaders">
          <div class="item">
            <div class="item-label">One Outside Leaders</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/expeditions/dhaulagiri?cm_sp=topnav_guide_featured_dhaulagiriexpedition" title="Expedition: Dhaulagiri">
          <div class="item">
            <div class="item-label">Expedition: Dhaulagiri</div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</div>


<div class="column">
  <div class="group">
      <h2 class="title">About Us</h2>
    <ul>
      <li>
        <a href="/campaign/theguide?cm_sp=topnav_guide_aboutus_ourfounder" title="Our Founder">
          <div class="item">
            <div class="item-label">Our Founder</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/awards?cm_sp=topnav_guide_aboutus_awardwinners" title="Award Winners">
          <div class="item">
            <div class="item-label">Award Winners</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/sustainability?cm_sp=topnav_guide_aboutus_sustainability" title="Sustainability">
          <div class="item">
            <div class="item-label">Sustainability</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/content/be-the-change?cm_sp=topnav_guidepost_aboutus_bethechange" title="Be the Change">
          <div class="item">
            <div class="item-label">Be the Change</div>
          </div>
        </a>
      </li>

      <li>
        <a href="//careers.eddiebauer.com/?cm_sp=topnav_guide_aboutus_careers" title="Careers">
          <div class="item">
            <div class="item-label">Careers</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/100years?cm_sp=topnav_guide_aboutus_100yearanniversary" title="100 Year Anniversary">
          <div class="item">
            <div class="item-label">100 Year Anniversary</div>
          </div>
        </a>
      </li>

    </ul>
  </div>


  <div class="group">
    <h2 class="title">Guides & Athletes</h2>

    <ul>
      <li>
        <a href="/campaign/summiting-antisana?cm_sp=topnav_guidepost_guidesandathletes_summitingantisana" title="Summiting Antisana">
          <div class="item">
            <div class="item-label">Summiting Antisana</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/guide-built-process" title="The Guide Built Process">
          <div class="item">
            <div class="item-label">The Guide Built Process</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/guides?cm_sp=topnav_guide_guidesandathletes_meettheteam" title="Meet the Team">
          <div class="item">
            <div class="item-label">Meet the Team</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/expeditions" title="Expeditions">
          <div class="item">
            <div class="item-label">Expeditions</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/k2-feature-film?cm_sp=topnav_guide_guidesandathletes_k2-featurefilm" title="K2: Feature Film">
          <div class="item">
            <div class="item-label">K2: Feature Film</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/leaders?cm_sp=topnav_guide_guidesandathletes_oneoutsideleaders" title="One Outside Leaders">
          <div class="item">
            <div class="item-label">One Outside Leaders</div>
          </div>
        </a>
      </li>
    </ul>
  </div>


  <div class="group">
    <h2 class="title">Partnerships</h2>

    <ul>
      <li>
        <a href="/campaign/americanforests?cm_sp=topnav_guide_partnerships_americanforests" title="American Forests">
          <div class="item">
            <div class="item-label">American Forests</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/theheroesproject?cm_sp=topnav_guide_partnerships_theheroesproject" title="The Heroes Project">
          <div class="item">
            <div class="item-label">The Heroes Project</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/the-venture-out-project?cm_sp=topnav_guide_partnerships_theventureoutproject" title="The Venture Out Project">
          <div class="item">
            <div class="item-label">The Venture Out Project</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/high-fives-foundation?cm_sp=topnav_guide_partnerships_highfivesfoundation" title="High Fives Foundation">
          <div class="item">
            <div class="item-label">High Fives Foundation</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/the-juniper-fund?cm_sp=topnav_guide_partnerships_juniperfund" title="The Juniper Fund">
          <div class="item">
            <div class="item-label">The Juniper Fund</div>
          </div>
        </a>
      </li>

    </ul>
  </div>


  <div class="group">
    <a href="/campaign/find-yourself-outside?cm_sp=topnav_guide_findyourselfoutside" title="Find Yourself Outside">
      <h2 class="title">Find Yourself Outside</h2>
    </a>

    <ul>
      <li>
        <a href="/campaign/find-yourself-outside/stories?cm_sp=topnav_guide_findyourselfoutside_stories" title="Stories">
          <div class="item">
            <div class="item-label">Stories</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/find-yourself-outside/outbound-collective?cm_sp=topnav_guide_findyourselfoutside_outboundcollective" title="The Outbound Collective">
          <div class="item">
            <div class="item-label">The Outbound Collective</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/find-yourself-outside/everyday-wellness?cm_sp=topnav_guide_findyourselfoutside_everydaywellness" title="Everyday Wellness">
          <div class="item">
            <div class="item-label">Everyday Wellness</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/find-yourself-outside/sleep-under-the-stars?cm_sp=topnav_guide_findyourselfoutside_sleepunderthestars" title="Sleep Under the Stars">
          <div class="item">
            <div class="item-label">Sleep Under the Stars</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/find-yourself-outside/eb-field-experts?cm_sp=topnav_guide_findyourselfoutside_ebfieldexperts" title="EB Field Experts">
          <div class="item">
            <div class="item-label">EB Field Experts</div>
          </div>
        </a>
      </li>

      <li>
        <a href="/campaign/one-outside-film-grant?cm_sp=topnav_guide_featured_filmgrant" title="One Outside Film Grant">
          <div class="item">
            <div class="item-label">One Outside Film Grant</div>
          </div>
        </a>
      </li>
    </ul>
  </div>

</div>
</div>`
